import { useEffect, useState } from "react";
import type { Character } from "@/lib/api";
import { avatarUrl } from "@/lib/api";

export function CharacterAvatar({ character, className = "h-8 w-8" }: { character?: Character; className?: string }) {
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(character?.id && character.avatar_key && !failed);

  useEffect(() => {
    setFailed(false);
  }, [character?.id, character?.avatar_key]);

  return (
    <span
      className={`relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full text-base ${className}`}
      style={{ background: character?.color ?? "#333" }}
    >
      <span aria-hidden="true">{character?.avatar_emoji ?? "🤖"}</span>
      {showImage && (
        <img
          src={`${avatarUrl(character!.id!)}?v=${encodeURIComponent(character!.avatar_key ?? "")}`}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          onError={() => setFailed(true)}
        />
      )}
    </span>
  );
}
